import CurrencyFormatter from '@apigrowfinance/pbolt-currency-formatter';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import LimitBar from '@components/limitBar/LimitBar';
import { useAccount } from '@contexts/AccountProvider';
import useGetLimits from '@hooks/queries/useGetLimits';

export interface CreditLimitPanelContainerProps {
    clickableVariant?: boolean;
}

const CreditLimitPanelContainer = ({
    clickableVariant = true,
}: CreditLimitPanelContainerProps) => {
    const { accountId } = useParams();
    const { account, program } = useAccount();
    const navigate = useNavigate();

    const { data: limits, isLoading: limitsLoading } = useGetLimits(+accountId);

    const denominatorValue = limits?.total_credit_limit;
    const primaryStackValue =
        limits?.total_credit_limit - limits?.available_credit_limit;
    const secondaryStackValue = account?.blocked_amount;
    const onClick = () => {
        navigate(
            `/${account?.account_id}/customers/${account?.customer_id}/limits`,
        );
    };
    const isOverLimit = limits?.available_credit_limit < 0;
    return (
        <LimitBar
            limitsLoading={limitsLoading}
            secondaryStackValue={secondaryStackValue}
            secondaryStackLabel={
                <FormattedMessage
                    id="CreditLimitPanelContainer.blocked"
                    defaultMessage="Blocked"
                />
            }
            primaryStackValue={primaryStackValue}
            denominatorValue={denominatorValue}
            remainingValue={account?.available_limit}
            primaryStackIsError={limits?.available_credit_limit < 0}
            {...(!!clickableVariant && { onClick: onClick })}
            title={
                <FormattedMessage
                    id="CreditLimitPanelContainer.CreditLimitPanel"
                    defaultMessage="Total credit limit"
                />
            }
            alert={
                isOverLimit && (
                    <FormattedMessage
                        id="CreditLimitPanelContainer.overTheLimit"
                        defaultMessage="This account is {amountOver} over the credit limit"
                        values={{
                            amountOver: (
                                <CurrencyFormatter
                                    variant="error"
                                    amount={limits?.available_credit_limit}
                                    currency={program?.currency_numeric_code}
                                />
                            ),
                        }}
                    />
                )
            }
        />
    );
};

export default CreditLimitPanelContainer;
